/*
 * fn: getRouteTab
 *
 * Finds the tab of a route by comparing the provided route to the tab route
 *
 */
import { getRouteConfig, isRouteParamType, type RouteType } from '@/defs/route'
import { type TabType } from '@/defs/tab'

const compare = (input?: unknown) => String(input ?? '')

export const getRouteTab = (route?: RouteType, tab?: string): TabType | undefined => {
  if (!route) return

  return getRouteConfig(route.section).tabs?.find((t) => {
    if (t.route.section !== undefined && t.route.section !== route.section) return false

    const params = Object.keys(t.route).filter(isRouteParamType)
    if (!params.every((param) => compare(route[param]) === compare(t.route[param]))) return false

    return compare(t.route.tab) === compare(tab)
  })
}
